import theme from '@/theme';
import styled from '@emotion/styled';
import { Skeleton } from '@mui/material';

const ConversationItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
`;

const Bubble = styled.div<{ width: string }>`
    padding: 8px 16px;
    border: 1px solid ${theme.colors.black[300]};
    background-color: ${theme.colors.white};

    color: ${theme.colors.secondary[900]};
    font-size: 14px;
    font-weight: 400;
    width: ${props => props.width};
`;

const UserBubble = styled(Bubble)`
    border-radius: 16px 0px 16px 16px;
    align-self: flex-end;
`;

const AgentBubble = styled(Bubble)`
    border-radius: 0px 16px 16px 16px;
    align-self: flex-start;
`;

const getRandomWidth = () => {
    const min = 20;
    const max = 80;
    const randomWidth = Math.floor(Math.random() * (max - min + 1)) + min;
    return `${randomWidth}%`;
};

export const ConversationItemSkeleton = () => {
    return (
        <ConversationItemContainer>
            <UserBubble width={getRandomWidth()}>
                <Skeleton width="100%" height="100%" />
            </UserBubble>

            <AgentBubble width={getRandomWidth()}>
                <Skeleton width="100%" height="100%" />
            </AgentBubble>
        </ConversationItemContainer>
    );
};
